// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zo3i","colBig":"styles_colBig__1SB4k","colSmall":"styles_colSmall__1cJln"};